import type { ReactNode } from "react";
import "./Form.css";

/**
 * The one form-level error idiom (UX polish wave 3 — nine sites split across
 * three hand-rolled variants: an inline danger-red style prop with a literal
 * hex fallback, a bare `.form-error` class, and `Banner`). This is a
 * mutation's own failure message, rendered right above the form's actions —
 * distinct from `Banner`, which is for an ongoing condition, and from a
 * toast, which is for a transient one-off. Reuses the shared `.form-error`
 * class from `Form.css` so every site paints identically from a real token,
 * never a literal hex fallback the token fitness test can't see through.
 */
export function FormError({ children }: { children: ReactNode }) {
  return (
    <p className="form-error" role="alert">
      {children}
    </p>
  );
}
